import { Payout } from 'src/app/models/payout.model';

export interface PayoutsState {
  payouts: Payout[];
  isLoading: boolean;
  error: string | null;
  walletBalance: number;
  pagination: {
    totalRecords: number;
    pageSize: number;
    pageIndex: number;
  };
}

export const initialPayoutsState: PayoutsState = {
  payouts: [],
  isLoading: false,
  error: null,
  walletBalance: 0,
  pagination: {
    totalRecords: 0,
    pageSize: 6,
    pageIndex: 0,
  },
};
